var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.page,attrs:{"id":"page"}},[_c('AdsSection',_vm._l((_vm.ads),function(ref){
var adUnitId = ref.adUnitId;
var dimensions = ref.dimensions;
return _c('div',{key:adUnitId,class:_vm.$style.slot,style:({
        width: _vm.getWidth(dimensions),
        height: _vm.getHeight(dimensions)
      }),attrs:{"id":adUnitId,"about":_vm.getWidth(dimensions)}},[_c('p',[_c('strong',[_vm._v(_vm._s(adUnitId))])]),_c('p',[_vm._v("( "+_vm._s(_vm.getWidth(dimensions))+" x "+_vm._s(_vm.getHeight(dimensions))+" )")]),(dimensions.length > 1)?_c('p',[_vm._v("( Mode: "+_vm._s(_vm.isMobile() ? 'Mobile' : 'Desktop')+" )")]):_vm._e()])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }